import { Avatar, Stack, SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { NoResultsImage2 } from 'Images';

interface INoResults {
  textSearch?: string;
  textSx?: SxProps;
}

export const NoResults2 = ({ textSearch, textSx }: INoResults) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.General);

  return (
    <Stack
      direction='column'
      alignItems='center'
      justifyContent='center'
      textAlign='center'
    >
      <Avatar
        alt=''
        src={NoResultsImage2}
        sx={{
          width: isDesktop ? '400px' : '130px',
          height: isDesktop ? '307px' : '100px',
          margin: '0 0 10px 0',
        }}
      />
      <Typography
        component='h2'
        variant='h3'
        margin={isDesktop ? '0 0 16px 0' : '0 0 12px 0'}
      >
        {dictionary.noAdvancedSearchResults}
      </Typography>
      <Typography variant='body3' sx={{ ...textSx }}>
        {textSearch ? textSearch : dictionary.tryChangingSearch}
      </Typography>
    </Stack>
  );
};
